import type { MyCartUpdateAction, ResourceIdentifierInput } from "@graphql/generated/types";

/**
 * Builds one setLineItemSupplyChannel action per line item so the pickup store is
 * applied to (or cleared from) every item in a Click & Collect cart, not just the last.
 * For C&C all items are fulfilled from the same store, and the backend derives
 * PickupStoreId from any line's supplyChannel, so every line must carry it.
 *
 * To clear the channel, pass a supplyChannel without an id/key: setLineItemSupplyChannel
 * unsets the reference when supplyChannel is omitted, so the field is dropped from the
 * action rather than sent as an (invalid) empty resource identifier.
 */
export const buildSupplyChannelActions = (
    lineItems: readonly { id: string }[],
    supplyChannel: ResourceIdentifierInput
): MyCartUpdateAction[] =>
    lineItems.map((lineItem) => ({
        setLineItemSupplyChannel:
            supplyChannel.id || supplyChannel.key
                ? { lineItemId: lineItem.id, supplyChannel }
                : { lineItemId: lineItem.id },
    }));
